class UiMessageCodeHelpers {
  uiMessageState = {
    ConfirmNoSale: 6,
    ConfirmSold: 2,
    ConfirmSubjectTo: 4,
    DebuggingErrorsOff: 51,
    DebuggingErrorsOn: 50,
    FocusBidButton: 104,
    FocusFloorBidderBadge: 101,
    FocusIndvMessageInput: 107,
    FocusLaneMessageInput: 108,
    FocusOpenItem: 103,
    FocusPinMessageInput: 109,
    FocusSidePanelSearch: 105,
    FocusStartingBidAmount: 102,
    NoSale: 5,
    ReRun: 7,
    RemoveFocus: 100,
    RemoveModalFocus: 106,
    Resume: 8,
    Running: 9,
    Sold: 1,
    SubjectTo: 3,
  };

  uiMessageStateAggregate = {
    Debugging: [50, 51],
    DecisionResetState: [7, 8, 9],
    DecisionState: [1, 2, 3, 4, 5, 6],
    FocusResetState: [100],
    FocusState: [101, 102, 103, 104, 107, 108, 109],
    ModalFocusResetState: [106],
    ModalFocusState: [105],
  };

  _getUiAggStateKeyByValue = (keyValue) => {
    for (let [key, value] of Object.entries(this.uiMessageStateAggregate)) {
      if (value.includes(keyValue)) return key;
    }
  };

  _getUiStateKeyByValue = (keyValue) => {
    for (let [key, value] of Object.entries(this.uiMessageState)) {
      if (isNaN(keyValue)) {
        if ([key].includes(keyValue)) return { key, value };
      } else {
        if ([value].includes(keyValue)) return { key, value };
      }
    }
  };

  getUiStateResult = (value) => {
    try {
      const uiState = this._getUiStateKeyByValue(value);
      const val = uiState?.value;

      if (!val) return;

      const getReturnObject = (type, obj, overrideValue) => {
        let result = Object.assign({ type }, obj);
        if (overrideValue) {
          result = Object.assign(result, { value: overrideValue });
        }
        return result;
      };

      const aggKey = this._getUiAggStateKeyByValue(val);
      if (aggKey === 'DecisionResetState')
        return getReturnObject('decision', uiState, 0);

      if (aggKey === 'DecisionState')
        return getReturnObject('decision', uiState);

      if (aggKey === 'FocusResetState')
        return getReturnObject('focus', uiState, 0);

      if (aggKey === 'FocusState') return getReturnObject('focus', uiState);

      if (aggKey === 'ModalFocusResetState')
        return getReturnObject('modalFocus', uiState, 0);

      if (aggKey === 'ModalFocusState')
        return getReturnObject('modalFocus', uiState);

      if (aggKey === 'Debugging') return getReturnObject('debugging', uiState);

      return getReturnObject('unknown', uiState, 0);
    } catch (err) {
      console.error('getUiStateResult', { err, value });
    }
  };
}

export default new UiMessageCodeHelpers();
